/**
 * Context Tag Select
 * 
 * Dropdown for selecting a context tag from customer-defined options.
 * Only enabled during New/Ready status (set once, early).
 * Context is stable during delivery and survives session changes.
 */

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLanguage } from "@/contexts/LanguageContext";

interface ContextTagSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  disabled?: boolean;
}

export function ContextTagSelect({ value, onChange, options, disabled }: ContextTagSelectProps) {
  const { t } = useLanguage();

  if (!options || options.length === 0) return null;

  return (
    <Select 
      value={value || ""} 
      onValueChange={(val) => onChange(val === "__none__" ? "" : val)}
      disabled={disabled}
    >
      <SelectTrigger className="h-9">
        <SelectValue placeholder={t("orders.labels.contextPlaceholder")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">— {t("common.none")} —</SelectItem>
        {options.map((ctx) => (
          <SelectItem key={ctx} value={ctx}>
            {ctx}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
